export const getWeekDay = day => {
  switch (day) {
    case '2019-11-18':
      return 'Segunda-Feira'
    case '2019-11-19':
      return 'Terça-Feira'
    case '2019-11-20':
      return 'Quarta-Feira'
    case '2019-11-21':
      return 'Quinta-Feira'
    case '2019-11-22':
      return 'Sexta-Feira'
    case '2019-11-23':
      return 'Sábado'
    default:
      return 'Domingo'
  }
}
